/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-27T11:47:12-08:00
* @Email:  daniel@reflexmedia.com
* @Last modified by:   Daniel
* @Last modified time: 2017-02-09T10:00:27-08:00
*/



import React, { Component } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { spacing, dimensions, color } from '../../../style';

const style = StyleSheet.create({

  root: {
    ...spacing.MARGIN_BOTTOM_LG
  },

  title: {
    borderBottom: '1px solid #ebebeb',
    paddingBottom: '8px',
    marginBottom: '14px',
    fontWeight: '600',
    fontSize: '16px',

    [dimensions.SCREEN_MAX_MD]: {
      paddingLeft: '8px',
      marginBottom: '0'
    }
  },

  detailsItem: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 0',
    margin: '0', // remove margins added in chrome browser

    [dimensions.SCREEN_MAX_MD]: {
      borderBottom: '1px solid #ebebeb',
      padding: '14px 10px'
    }
  },

  label: {
    color: color.GREY_2
  },

  info: {
    fontSize: '14px'
  }
})



class MoreInfo extends Component {
  render() {
    return (
      <div className={css(style.root)}>
        <div className={css(style.title)}>More Info {this.props.profile.username}</div>
        <dl className={css(style.detailsItem)}>
          <dt className={css(style.label)}>Education</dt>
          <dd className={css(style.info)}>{this.props.profile.education}</dd>
        </dl>
        <dl className={css(style.detailsItem)}>
          <dt className={css(style.label)}>Religion</dt>
          <dd className={css(style.info)}>{this.props.profile.religion}</dd>
        </dl>
        <dl className={css(style.detailsItem)}>
          <dt className={css(style.label)}>Smoking</dt>
          <dd className={css(style.info)}>{this.props.profile.smoking}</dd>
        </dl>
        <dl className={css(style.detailsItem)}>
          <dt className={css(style.label)}>Drinking</dt>
          <dd className={css(style.info)}>{this.props.profile.drinking}</dd>
        </dl>
      </div>
    );
  }
}

export default MoreInfo;



// WEBPACK FOOTER //
// ./src/components/pages/Profile/MoreInfo.jsx